import services from '@/services'
import Pagination from '@/components/Pagination'
import CourseCalendar from '@/components/course/CourseCalendar'
import CourseSelect from '@/components/course/CourseSelect'
import TargetSelect from '@/components/course/TargetSelect'
import CategorySelect from '@/components/course/CategorySelect'
import CoachSelect from '@/components/coach/CoachSelect'
import CertSelect from '@/components/coach/CertSelect'
import PageTable from '@/components/PageTable'
import ImageUpload from '@/components/ImageUpload'
import Ckeditor from '@/components/Ckeditor'
import ManufacturerSelect from '@/components/manufacturer/ManufacturerSelect'
import UserTypeSelect from '@/components/user/UserTypeSelect'
import DropdownSelect from '@/components/DropdownSelect'

export default {
  install: function (Vue, options) {
    // 注入服务
    Vue.prototype.services = services
    Vue.prototype.api = services.api
    // 注册组件
    Vue.component('Pagination', Pagination)
    Vue.component('CourseCalendar', CourseCalendar)
    Vue.component('CourseSelect', CourseSelect)
    Vue.component('TargetSelect', TargetSelect)
    Vue.component('CategorySelect', CategorySelect)
    Vue.component('CoachSelect', CoachSelect)
    Vue.component('CertSelect', CertSelect)
    Vue.component('PageTable', PageTable)
    Vue.component('ImageUpload', ImageUpload)
    Vue.component('Ckeditor', Ckeditor)
    Vue.component('ManufacturerSelect', ManufacturerSelect)
    Vue.component('UserTypeSelect', UserTypeSelect)
    Vue.component('DropdownSelect', DropdownSelect)
  }
}



// WEBPACK FOOTER //
// ./src/config/VueConfig.js